import { effect, Injector } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Lux } from '@roosevelt/common-ui-lib/core';

export function syncLuxSliceToStorage<TState extends object, TSlice>(
  lux: Lux<TState>,
  injector: Injector,
  storage: Storage,
  storageKey: string,
  selectSlice: (state: TState) => TSlice
): void {
  const allChanges = toSignal(lux.allChanges(), {
    initialValue: undefined,
    injector
  });

  effect(
    () => {
      const state = allChanges();
      if (state !== undefined) {
        storage.setItem(storageKey, JSON.stringify(selectSlice(state)));
      }
    },
    { injector }
  );
}

